import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    TemplateRef,
    ViewChild,
    ViewContainerRef,
  } from '@angular/core';
  import { v4 } from 'uuid';
  
  @Component({
    selector: 'asw-text-with-tooltip',
    templateUrl: './text-with-tooltip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class TextWithTooltipComponent implements OnInit {
    public ID_PREFIX = 'tooltip_';
    @ViewChild('template', { static: true })
    template!: TemplateRef<unknown>;
    /** ツールチップのid */
    @Input()
    public id = v4();
    @Input()
    public tooltipText = '';
    /** ツールチップの表示内容 */
    @Input()
    public tooltipContent?: string;
    /** 追加の上向きオフセット距離 */
    @Input()
    public tooltipTop = 0;
    /** ツールチップ表示方式 */
    @Input()
    public tooltipDisplayType: 'tap' | 'hover' = 'tap';
    @Input()
    public displayHelperIcon = true;
  
    constructor(private readonly viewContainerRef: ViewContainerRef) {}
  
    ngOnInit(): void {
      this.viewContainerRef.createEmbeddedView(this.template);
    }
  }